import React from 'react'
import LessonPreview from 'src/message/LessonPreview'
import ResponsePreview from 'src/message/ResponsePreview'
import { ChatMessageLink } from '../../api/patientConversation'

type Props = { link: ChatMessageLink; onRemove?: () => void }

// Standard's previews, shown above its composer and inside a message; only a response has a time.
const LinkedContentCard = ({ link, onRemove }: Props) =>
  link.createdAt ? (
    <ResponsePreview
      response={{ title: link.title, category: link.category, createdAt: new Date(link.createdAt) }}
      onRemoveResponse={onRemove}
    />
  ) : (
    <LessonPreview lesson={link} onRemoveLesson={onRemove} />
  )

export default LinkedContentCard
